import axios from "axios";

import { ParseError } from "./error/ParseError";
import { getToken, getConfig } from "helpers/utility";

const SafeUrlAssembler = require("safe-url-assembler");

const execFormData = async (props) => {
  let { url, file, param, success, fail, always } = props;
  let instance = axios.create({
    timeout: 100000,
    headers: {
      "Accept-Version": 1,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data;boundary=&",
      language: "fa",
    },
  });

  let token = getToken().get("idToken");
  if (token)
    instance.defaults.headers.common["Authorization"] = "Bearer " + token;

  let data = new FormData();
  data.append("qqfilename", file);
  if (param) {
    param.forEach((element) => {
      if (element.array) {
        if (element.value) {
          element.value.forEach((arrayValue) => {
            data.append(element.key, arrayValue);
          });
        }
      } else data.append(element.key, element.value);
    });
  }

  if (success == null || success === undefined) {
    success = function (res) {
      return res.data;
    };
  }

  return await instance
    .post(url, data)
    .then(success, function (response) {
      if (fail) return fail(response);
      else {
        ParseError(response);
      }
    })
    .finally(function () {
      if (always) return always();
    })
    .catch((error) => {
      console.log(3333, error);
      return ParseError(error);
    });
};

const execJson = async (props) => {
  let { url, method, param, success, fail, always } = props;

  /*
  console.log("------------------------   Call API   ------------------------")
  console.log(url)
  console.log(param)
  console.log("--------------------------------------------------------------")
  */
  let instance = axios.create({
    timeout: 60000,
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json; charset=utf-8",
      language: "fa",
      UseDeveloperExceptionPage: true,
    },
  });

  let token = getToken().get("idToken");

  if (token)
    instance.defaults.headers.common["Authorization"] = "Bearer " + token;

  if (success == null || success === undefined) {
    success = (res) => res.data;
  }

  if (method.toLowerCase() === "post") {
    return await instance
      .post(url, JSON.stringify(param))
      .then(success, (response) => {
        if (fail) return fail(response);
        else {
          ParseError(response);
        }
      })
      .catch((error) => {
        ParseError(error);
      });
  } else if (method.toLowerCase() === "get")
    return await instance
      .get(url, { params: JSON.stringify(param) })
      .then(success)
      .catch((error) => ParseError(error));
  else if (method.toLowerCase() === "delete") {
    return await instance
      .delete(url, { data: JSON.stringify(param) })
      .then(success)
      .catch((error) => ParseError(error));
  } else {
    return await axios
      .request({
        method: method,
        url: url,
        data: JSON.stringify(param),
        headers: { "content-type": "application/json" },
      })
      .then(success, (response) => {
        if (fail) return fail(response);
        else ParseError(response);
      })
      .finally(() => {
        if (always) return always();
      })
      .catch((error) => ParseError(error));
  }
};

const apiHelper = {
  getServerUrl: () => {
    const config = getConfig();
    return config.SERVER_URL;
  },
  getIdentityServerUrl: () => {
    const config = getConfig();
    return config.IDENTITY_URL;
  },
  getTempServerUrl: () => {
    const config = getConfig();
    return config.TEMP_URL;
  },
  getNewsFeedServerUrl: () => {
    const config = getConfig();
    return config.NEWSFEED_URL;
  },
  getContentServerUrl: () => {
    const config = getConfig();
    return config.CONTENT_URL;
  },
  createUrl: (props) => {
    const config = getConfig();
    const { template, params, query, filter, serverurl } = props;
    let srvurl = serverurl || config.SERVER_URL;

    let url = new SafeUrlAssembler(srvurl).template(template);
    if (params !== undefined && params !== null) url = url.param(params);
    if (query !== undefined && query !== null) url = url.query(query);

    let strUrl = url.toString();
    if (filter)
      if (strUrl.indexOf("?") > -1) strUrl += "&" + filter;
      else strUrl += "?" + filter;
    return strUrl;
  },

  exec: async ({ url, method, param, success = null, fail, always }) => {
    return await execJson({ url, method, param, success, fail, always });
  },

  execFormData: async ({ url, file, param, success = null, fail, always }) => {
    return await execFormData({ url, file, param, success, fail, always });
  },

  saveContent: async ({ url, file, param, success = null, fail, always }) => {
    return await execFormData({ url, file, param, success, fail, always });
  },
};
export default apiHelper;
